import React, { Component } from 'react'
import { Button, FormGroup, FormControl, DropdownButton, MenuItem, Popover, OverlayTrigger, ControlLabel, Col, Collapse } from 'react-bootstrap'
import * as propertyCodesForForms from '../../../../constants/propertyCodesForForms'
import { translate } from 'react-translate'

@translate("FormAppraisals")
export default class FormAppraisals extends Component {

  constructor (props) {
    super(props)
		let t = this.props.t;
    this.state = {
      name: '',
      phone: '',
      email: '',
      address: '',
      company: '',
      body: '',
      locality: '',
      operation_type: 'venta',
      property_type: 'vivienda',
      covered_area: '',
      landed_area: '',
      validateName : '',
      validatePhone : '',
      validateEmail : '',
      validateAddress : '',
      validateLocality : '',
      validateCovered : '',
      validateLanded : '',
      open: false,
      landedAreaPlaceholder: t('Superficie_terreno_aproximada'),
      propertyTypePlaceHolder: t('Tipo_de_propiedad'),
      coverAreaPlaceholder: t('Superficie_cubierta_aproximada')
    }

    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangePhone = this.handleChangePhone.bind(this);
    this.handleChangeEmail = this.handleChangeEmail.bind(this);
    this.handleChangeAddress = this.handleChangeAddress.bind(this);
    this.handleChangeCompany = this.handleChangeCompany.bind(this);
    this.handleChangeBody = this.handleChangeBody.bind(this);
    this.handleChangeLocality = this.handleChangeLocality.bind(this);
    this.handleChangeOperationType = this.handleChangeOperationType.bind(this);
    this.handleChangePropertyType = this.handleChangePropertyType.bind(this);
    this.handleChangeCoveredArea = this.handleChangeCoveredArea.bind(this);
    this.handleChangeLandedArea = this.handleChangeLandedArea.bind(this);
    this.selectOperationType = this.selectOperationType.bind(this);
  }

  handleChangeName(event) {
    let state = ''
    this.setState({name: event.target.value});
    state = this._validate('name')
    this.setState({validateName: state})
  }
  handleChangePhone(event) {
    let state = ''
    this.setState({phone: event.target.value});
    state = this._validate('phone')
    this.setState({validatePhone: state})
  }

  handleChangeEmail(event) {
    let state = ''
		var that = this;
    this.setState({email: event.target.value}, () => {
			state = that._validate('email')
			that.setState({validateEmail: state})
		});


  }

  handleChangeAddress(event) {
    let state = ''
    this.setState({address: event.target.value});
    state = this._validate('address')
    this.setState({validateAddress: state})
  }

  handleChangeCompany(event) {
    this.setState({company: event.target.value});
  }

  handleChangeBody(event) {
    this.setState({body: event.target.value});
  }

  handleChangeLocality(event) {
    let state = ''
    this.setState({locality: event.target.value});
    state = this._validate('locality')
    this.setState({validateLocality: state})
  }

  handleChangeOperationType(event) {
    this.setState({operation_type: event.target.value});
  }

  handleChangePropertyType(value) {
    this.setState({propertyTypePlaceHolder:value})
    this.setState({property_type: value});
  }

  handleChangeCoveredArea(value) {
    this.setState({coverAreaPlaceholder: value})
    this.setState({covered_area: value});
  }

  handleChangeLandedArea(value) {
    this.setState({landedAreaPlaceholder: value});
    this.setState({landed_area: value});
  }

  selectOperationType(e){
    this.setState({operation_type: e.currentTarget.value});
  }

  _handleSubmit(e){
    e.preventDefault();
    if (this.state.validateName === 'success') {
      if (this.state.validatePhone === 'success') {
        if (this.state.validateEmail  === 'success') {
          let form = {
            name: this.state.name,
            phone: this.state.phone,
            email: this.state.email,
            company: this.state.company,
            text: `
              Solicitud de tasación: ${this.state.body} |
              Información de propiedad:  Dirección: ${this.state.address}
              | Localidad: ${this.state.locality}
              | Área cubierta: ${this.state.covered_area}
              | Superficie Total: ${this.state.landed_area}
              | TIPO PROPIEDAD: ${this.state.property_type}
              | TIPO OPERACION: ${this.state.operation_type}
              ${ this.state.company ? `| EMPRESA: ${this.state.company}` : ''}
            `,
            tags: [
              'Consulta Web: Web ljramos',
              `TIPO OPERACION: ${this.state.operation_type}`,
              `TIPO PROPIEDAD: ${this.state.property_type}`,
              'SECTOR: Landing Tasaciones',
              `Dirección: ${this.state.address}`,
              `Localidad: ${this.state.locality}`,
              `Área cubierta: ${this.state.covered_area}`,
              `Superficie Total: ${this.state.landed_area}`,
            ],
            properties: [propertyCodesForForms['tasaciones']], // this is to hardcode a property code to redirect forms
            address: this.state.address,
            locality: this.state.locality,
            covered_area: this.state.covered_area,
            landed_area: this.state.landed_area,
            property_type: this.state.property_type,
            operation_type: this.state.operation_type,

          }
          this.props.onSubmitAppraisalForm(form)
        }
      }
    }
  }

  _validate(value) {
    let patt = ''
    switch(value) {
      case 'name':
        patt = /^[a-zA-Z_]+( [a-zA-Z_]+)*$/
        if ((this.state.name !== '') && (patt.test(this.state.name))) {
          return 'success'
        }
        else {
          return 'error'
        }
        break;
      case 'phone':
        patt = /^[0-9]+$/
        if ((this.state.phone !== '') && (patt.test(this.state.phone))) {
          return 'success'
        }
        else {
          return 'error'
        }
        break;
      case 'email':
        patt = /^[a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$/
        if ((this.state.email !== '') && (patt.test(this.state.email))) {
          return 'success'
        }
        else {
          return 'error'
        }
        break;
      case 'address':
        if (this.state.address !== '') {
          return 'success'
        }
        else {
          return 'error'
        }
        break;
      case 'locality':
        if (this.state.locality !== '') {
          return 'success'
        }
        else {
          return 'error'
        }
        break;
    }
  }

  render () {

    let value = this.state

    const { onSubmitAppraisalForm, send, resetContactForm, t } = this.props

    if (send) {
      return(
        <div className="thanks-box">
          <h1>{t("Mensaje_Exito")}</h1>
          <h2>{t("Texto_Exito")}</h2>
          <Button type="button" className="btn-form-reset" onClick={() => resetContactForm()}>
            {t("Texto_Exito_2")}
          </Button>
        </div>
      )
    }
    else{
      return (
        <div className={(this.state.open == true ? 'column-form form-open' : 'column-form form-close')}>
          <h3 className="title-form"> {t("Datos_Personales")} </h3>
          <form>
            <Col sm={12} md={12}>
              <div className="inputs-row">
                <Col sm={12} md={6}>
                  <FormGroup validationState={this.state.validateName} className="required-field">
                    <FormControl type="text" placeholder={t("Nombre_Completo")} value={this.state.name}  onChange={this.handleChangeName} />
                  </FormGroup>
                  <FormGroup validationState={this.state.validatePhone} className="required-field">
                    <FormControl type="text" placeholder={t("Telefono")} value={this.state.phone} onChange={this.handleChangePhone}/>
                  </FormGroup>
                </Col>
                <Col sm={12} md={6}>
                  <FormGroup validationState={this.state.validateEmail} className="required-field">
                    <FormControl type="text" placeholder={t("Email")} value={this.state.email}  onChange={this.handleChangeEmail}/>
                  </FormGroup>
                  <FormGroup validationState=''>
                    <FormControl type="text" placeholder={t("Empresa")} value={this.state.company}  onChange={this.handleChangeCompany} />
                  </FormGroup>
                </Col>
              </div>
              <Col md={12}>
                <FormGroup validationState="">
                  <FormControl placeholder={t("Comentarios")} componentClass="textarea" value={this.state.body}  onChange={this.handleChangeBody}/>
                </FormGroup>
              </Col>
            </Col>
            <Col md={12} sm={12} className="col-collapse">
              <Button className={(this.state.open == true ? 'btn-open' : 'btn-close')} onClick={ ()=> this.setState({ open: !this.state.open })}>
	              {t("Datos_Propiedad")}
                <i className="fa fa-angle-down fa-lg" aria-hidden="true"></i>
              </Button>
              <Collapse in={this.state.open}>
                <Col sm={12} md={12}>
                  <div className="inputs-row">
                    <Col sm={12} md={6}>
                      <FormGroup validationState={this.state.validateAddress}>
                        <FormControl type="text" placeholder={t("Direccion")} value={this.state.address}  onChange={this.handleChangeAddress} />
                      </FormGroup>
                      <FormGroup>
                        {/*<FormControl type="text" placeholder="Superfice terreno aproximada" value={this.state.landed_area}  onChange={this.handleChangeLandedArea}/> */}
                        <DropdownButton id="dropdown-form" title={this.state.landedAreaPlaceholder}>
                          <MenuItem key="100" onClick={ () => this.handleChangeLandedArea('100m2') }>100m2</MenuItem>
                          <MenuItem key="300" onClick={ () => this.handleChangeLandedArea('300m2') }>300m2</MenuItem>
                          <MenuItem key="500" onClick={ () => this.handleChangeLandedArea('500m2') }>500m2</MenuItem>
                          <MenuItem key="1000" onClick={ () => this.handleChangeLandedArea('1000m2') }>1000m2</MenuItem>
                          <MenuItem key="1500" onClick={ () => this.handleChangeLandedArea('1500m2') }>1500m2</MenuItem>
                          <MenuItem key="2000" onClick={ () => this.handleChangeLandedArea('2000m2') }>2000m2</MenuItem>
                        </DropdownButton>
                      </FormGroup>
                      <FormGroup>
                        <DropdownButton id="dropdown-form" title={this.state.propertyTypePlaceHolder}>
                          <MenuItem key="casa" onClick={ () => this.handleChangePropertyType('Casa')}>Casa</MenuItem>
                          <MenuItem key="edificio" onClick={ () => this.handleChangePropertyType('Edificio')}>Edificio</MenuItem>
                          <MenuItem key="departamento" onClick={ () => this.handleChangePropertyType('Departamento')}>Departamento</MenuItem>
                          <MenuItem key="cochera" onClick={ () => this.handleChangePropertyType('Cochera')}>Cochera</MenuItem>
                          <MenuItem key="oficina" onClick={ () => this.handleChangePropertyType('Oficina')}>Oficina</MenuItem>
                          <MenuItem key="industria" onClick={ () => this.handleChangePropertyType('Industria')}>Industria</MenuItem>
                          <MenuItem key="local" onClick={ () => this.handleChangePropertyType('Local')}>Local</MenuItem>
                          <MenuItem key="terreno" onClick={ () => this.handleChangePropertyType('Terreno')}>Terreno</MenuItem>
                          <MenuItem key="lote-barrio-cerrado" onClick={ () => this.handleChangePropertyType('Lote Barrio Cerrado')}>Lote en Barrio Cerrado</MenuItem>
                          <MenuItem key="campo" onClick={ () => this.handleChangePropertyType('Campo')}>Campo</MenuItem>
                          <MenuItem key="hotel" onClick={ () => this.handleChangePropertyType('Hotel')}>Hotel</MenuItem>
                        </DropdownButton>
                      </FormGroup>
                    </Col>
                    <Col sm={12} md={6}>
                      <FormGroup validationState={this.state.validateLocality}>
                        <FormControl type="text" placeholder="Localidad" value={this.state.locality}  onChange={this.handleChangeLocality} />
                      </FormGroup>
                      <FormGroup validationState={this.state.validateCovered}>
                        {/*<FormControl type="text" placeholder="Superfice cubierta aproximada" value={this.state.covered_area}  onChange={this.handleChangeCoveredArea}/>
                        <FormGroup validationState={this.state.validateLanded}>*/}
                        <DropdownButton id="dropdown-form" title={this.state.coverAreaPlaceholder}>
                          <MenuItem key="100" onClick={ () => this.handleChangeCoveredArea('100m2') }>100m2</MenuItem>
                          <MenuItem key="300" onClick={ () => this.handleChangeCoveredArea('300m2') }>300m2</MenuItem>
                          <MenuItem key="500" onClick={ () => this.handleChangeCoveredArea('500m2') }>500m2</MenuItem>
                          <MenuItem key="1000" onClick={ () => this.handleChangeCoveredArea('1000m2') }>1000m2</MenuItem>
                          <MenuItem key="1500" onClick={ () => this.handleChangeCoveredArea('1500m2') }>1500m2</MenuItem>
                          <MenuItem key="2000" onClick={ () => this.handleChangeCoveredArea('2000m2') }>2000m2</MenuItem>
                        </DropdownButton>
                      </FormGroup>
                      <div className="input-types">
                        <p>Tipo de operación</p>
                        <form>
                          <input type="radio" name="venta" value="venta" checked={this.state.operation_type == 'venta' } onChange={this.selectOperationType}/>
                          <span className="sale">Venta</span>
                          <input type="radio" name="alquiler" value="alquiler" checked={this.state.operation_type == 'alquiler'} onChange={this.selectOperationType}/>
                          <span className="rent">Alquiler</span>
                        </form>
                      </div>
                    </Col>
                  </div>
                </Col>
              </Collapse>
              <Button type="button" className="btn-form" onClick={(e) => this._handleSubmit(e)}>
                {t("Solicitar_tasacion")}
              </Button>
            </Col>
          </form>
        </div>

      )
    }

  }
}



// WEBPACK FOOTER //
// ./src/features/PageAppraisals/components/AppraisalForm/AppraisalForm.comonent.js